import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";

import { GridItem } from "./GridItem";

export const ActivityScoresFeature = () => (
  <div className="border-primary rounded-sm border p-5">
    <div className="mb-1">
      <Typography.LabelLg weight="bold" color="text-default">
        {t("settings.community_ai.marketing_modal.activity_score.title")}
      </Typography.LabelLg>
    </div>
    <Typography.BodySm color="text-default">
      {t("settings.community_ai.marketing_modal.activity_score.description")}
    </Typography.BodySm>
    <div className="mt-4 grid grid-cols-2 gap-4">
      <GridItem
        property={t("settings.community_ai.marketing_modal.params.presence")}
        number="9.5"
      />
      <GridItem
        property={t(
          "settings.community_ai.marketing_modal.params.contribution",
        )}
        number="5.0"
        red
      />
      <GridItem
        property={t(
          "settings.community_ai.marketing_modal.params.participation",
        )}
        number="8.3"
      />
      <GridItem
        property={t("settings.community_ai.marketing_modal.params.connection")}
        number="8.5"
      />
    </div>
  </div>
);
